import CurrentFormReadonly from '../CurrentFormReadonly'

import useStyles from '../Forms/styles'

const FormsReadonly = () => {
  const classes = useStyles()

  return (
    <section className={classes.container}>
      <CurrentFormReadonly />
    </section>
  )
}

export default FormsReadonly
